(function () {
  function makeScrollable(scroller) {
    if (!scroller || scroller.dataset.pkCarousel) return;
    scroller.dataset.pkCarousel = '1';
  }

  function initAll() {
    document.querySelectorAll('ul.swatch-view-custom-image').forEach(makeScrollable);
    document.querySelectorAll('.product-form__input--swatch').forEach(makeScrollable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 100); });
})();
